import { Component, OnInit } from '@angular/core';
import { CompanypagesService } from "src/app/_services/companypages.service";
import { ActivatedRoute } from "@angular/router";
import { Router } from "@angular/router";
import {Title} from "@angular/platform-browser";

@Component({
    selector: 'app-companylist',
    templateUrl: './companylist.component.html',
    styleUrls: ['./companylist.component.scss'],
    standalone: false
})
export class CompanylistComponent implements OnInit {
  companyList = [];
  start = 0;
  end = 100;
  paginationOffset = 100;
  paginationArray = [];
  type = 'company';
  companyName = '';
  enteredCompanyName = '';
  city = '';
  industry = '';
  typeaheads = [];
  cityList = [];
  activePage = 0;
  totalCompanies = 0;
  lastPageNumber;
  prevPage = 1;
  timeout;
  filterApplied: boolean = false;
  industryid;
  
  constructor(private _companypagesservice: CompanypagesService, private _Activatedroute: ActivatedRoute, private router: Router, private titleService:Title) {}

  ngOnInit(): void {
    this.industryid = this._Activatedroute.snapshot.paramMap.get("industry")?.split('-').reverse()[0];
    this.getCompanyList(this.start,this.end);
    this.getTypeaheads('company');
    this.getTypeaheads('city');
  }

  getCompanyList(start,end){
    let industryWithoutSymbols = this.replaceSymbols(this.industry);
    this._companypagesservice.getCompanyList(start, end, this.paginationOffset, this.type, this.companyName, this.city,'',this.industryid).subscribe((data:any) => {
      if(data.status == 'success'){
        data.finalData.forEach((cluster:any) => {
          cluster.forEach((item:any) => {
            item.companyname = this._companypagesservice.removeHyphen(item.companyname);
            if(item && item.industry){
              this.industry = item.industry
            }
          })
        })
        this.companyList = data.finalData;
        this.paginationArray = data.pagesArray;
        this.lastPageNumber = this.paginationArray[this.paginationArray.length - 1];
        this.totalCompanies = data.totalCompanies;
      } else {
        this.companyList.length = 0; // for empty state
      }
    })
  }

  onKeyPress(type){
    this.filterApplied = true;
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.getTypeaheads(type);
    },500);
  }

  getTypeaheads(type){
    let industryWithoutSymbols = this.replaceSymbols(this.industry);
    switch (type){
      case 'company':
        this._companypagesservice.getCompanyList(0, 10, 0, 'typeahead-company', this.companyName, this.city, '', this.industryid).subscribe((data:any) => {
          if(data.status == 'success'){
            data.clist.forEach((item:any) => {
              item.companyname = this._companypagesservice.removeHyphen(item.companyname);
            })
            this.typeaheads = data.clist;
          }
        })
       
      break;
      case 'city':
        this._companypagesservice.getCompanyList(0, 10, 0, 'typeahead-city', this.companyName, this.city, '', this.industryid).subscribe((data:any) => {
          this.cityList = data.cityList;
        })
      break;
    }
  }
  
  pagination(type, load){
    let callApi = true;
    switch (type) {
      case "next":
        this.start += this.paginationOffset;
        this.end += this.paginationOffset;
        if(this.activePage < (Math.ceil(this.totalCompanies/this.paginationOffset))-1){
          this.activePage++;
        } else {
          callApi = false;
        }
        if (this.end > this.totalCompanies) this.end = this.totalCompanies;
        break;

      case "prev":
        this.end = this.start - 1;
        this.start -= this.paginationOffset;
        if (this.start < 0) {
          this.start = 1;
          this.end = this.paginationOffset;
        }
        if(this.activePage>=1){
          this.activePage--;
        } else {
          callApi = false;
        }
        break;
      
      case "page":
        if(load !=this.prevPage){
          this.prevPage = load;
          let pageNum;
          pageNum = this.activePage - 1;
          this.start = pageNum*this.paginationOffset;
          this.end = this.start + this.paginationOffset;
        } else{
          callApi = false;
        }
        break;
    }
    if(callApi){
      this.getCompanyList(this.start, this.end);
    }
  }

  applyFilter(type, val){
    switch(type){
      case 'city':
        this.city = val;
        this.getCompanyList(0,this.paginationOffset);
        this.getTypeaheads('city');
        this.filterApplied = true;
      break;
      case 'clearall':
        if(this.filterApplied){
          this.city = '';
          this.companyName = '';
          this.getCompanyList(0,this.paginationOffset);
          this.getTypeaheads('city');
          this.getTypeaheads('company');
        }
      break;
    }
  }

  searchRedirect(name,id){
    this.router.navigate([`/company-directory/${name}/${id}`]);
  }

  replaceSymbols(val:any){
    if(val.length>0){
      val = val.toString().replace(/\+/g,'xMl3Jk').replace(/\//g,'Por21Ld').replace(/&/g,'Ml32');
    }
    return val;
  }

  restoreSymbols(val:any){
    if(val.length>0){
      val = val.toString().replace(/xMl3Jk/g, '+' ).replace(/Por21Ld/g, '/').replace(/Ml32/g, '&');
    }
    return val;
  }
}
